export default "__VITE_ASSET__B4cl4D$W__";